<div class="card">
	<div class="card-header">
		<h4>Notifications</h4>
	</div>

	<div class="card-body">
		<form [formGroup]="filterForm" class="row g-3 mb-3 align-items-end">
			<div class="col-md-3">
				<app-form-range-date [(ngModel)]="dateRange" [ngModelOptions]="{ standalone: true }" (OnSelected)="dateSelected($event)" labelTitle="Date Range:" [position]="'right'" [range_type]="'RANGE_FUTURE'" [autoApply]="true"> </app-form-range-date>
			</div>

			<div class="col d-flex justify-content-end gap-3">
				<div>
					<label class="headerSearch mb-1 d-block">User:</label>
					<div class="input-group">
						<input type="text" class="form-control" placeholder="Search user..." [(ngModel)]="searchUser" [ngModelOptions]="{ standalone: true }" />
						<button class="btn btn-outline-secondary" *ngIf="searchUser" (click)="searchUser = ''">
							<i class="ri-close-line"></i>
						</button>
					</div>
				</div>
				<div>
					<label class="headerSearch mb-1 d-block">Type:</label>

					<div ngbDropdown>
						<button class="btn btn-primary" id="typeDrop" ngbDropdownToggle>
							{{ selectedType || "All" }}
						</button>

						<div ngbDropdownMenu aria-labelledby="typeDrop">
							<button ngbDropdownItem (click)="setType(null)">All</button>

							<button *ngFor="let t of notificationTypes" ngbDropdownItem (click)="setType(t)">
								{{ getTypeLabel(t) }}
							</button>
						</div>
					</div>
				</div>

				<div>
					<label class="headerSearch mb-1 d-block">Portal:</label>

					<div ngbDropdown>
						<button class="btn btn-primary" id="portalDrop" ngbDropdownToggle>
							{{ selectedPortal || "All" }}
						</button>

						<div ngbDropdownMenu aria-labelledby="portalDrop">
							<button ngbDropdownItem (click)="setPortal(null)">All</button>

							<button ngbDropdownItem (click)="setPortal('ADM')">Admin</button>

							<button ngbDropdownItem (click)="setPortal('CAL')">Caller</button>

							<button ngbDropdownItem (click)="setPortal('CUS')">Customer</button>
						</div>
					</div>
				</div>
			</div>
		</form>

		<div class="activity-item card shadow-sm mt-3" *ngFor="let n of filteredNotifications" [ngClass]="getPortalClass(n.portal)">
			<small class="text-muted card-date d-flex align-items-center gap-1">
				<i class="ri-calendar-line"></i>
				{{ n.created | utcToLocal }}
			</small>
			<div class="card-body position-relative">
				<div class="d-flex">
					<div class="avatar me-3 align-self-center">
						<span class="avatar-icon">
							<i [ngClass]="getAvatarIconClass(n.type)"></i>
						</span>
					</div>

					<div class="flex-grow-1">
						<div class="mb-1">
							<strong>{{ n.user_name }}</strong>
							<span class="text-muted ms-1">{{ getTypeLabel(n.type) }}</span>
						</div>

						<p class="mb-2">{{ n.message }}</p>

						<div class="d-flex gap-3 align-items-center flex-wrap">
							<a *ngIf="n.lead_id" [routerLink]="['/lead-edit', n.lead_id]" class="badge bg-light text-dark text-decoration-none d-flex align-items-center gap-1 fs-6">
								<i class="ri-search-line"></i>
								Lead: {{ n.lead_id }}
							</a>
							<a *ngIf="n.type === 'support_ticket'" [routerLink]="['/support-tickets']" [state]="{ ticketId: n.ticket_id }" (click)="modal.close()" class="badge bg-light text-dark text-decoration-none d-flex align-items-center gap-1 fs-6">
								<i class="ri-customer-service-2-line"></i>
								Support Ticket #{{ n.ticket_id }}
							</a>
							<span class="badge portal-badge fs-6" [ngClass]="getPortalBadgeClass(n.portal)">
								{{ getPortalLabel(n.portal ?? "-") }}
							</span>
							<span *ngIf="n.watched" class="badge bg-success fs-6">
								Viewed at: {{ n.watched | utcToLocal }}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="!loading && filteredNotifications.length === 0" class="text-center text-muted py-4">No notifications available.</div>
	</div>
</div>
